import React from 'react'
import Title from '../../components/Title/Title'
import './info.style.scss'
import { FaWhatsapp, FaEnvelope, FaHome, FaMountain, FaSkiing, FaHotel, FaInstagram } from 'react-icons/fa';
import Button from '../../components/Button/Button';
import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { KEY } from '../../utils/Const';

const Info = () => {
    const now = new Date();
    const [goHome, setGoHome] = useState(false);
    return (
        <div className='info-box'>
            {goHome && <Navigate to="/" />}
            <label className='info-title'>informazioni</label>
            {/* <div className='button-home'>
                <Button onClick={() => setGoHome(true)}><FaHome /></Button>
            </div> */}
            <div className='info-list'>
                <ul>
                    <li>Dal 29 Dicembre {now.getFullYear()} al 2 Gennaio {now.getFullYear() + 1}</li>
                    <label>Inizia con la cena e partenza dopo la colazione.</label><br />
                    <label>Non è prevista una partecipazione parziale al campo.</label>
                    <li>età</li>
                    <label>dai 18 anni in su.</label>
                    <li>costo</li>
                    <label>240€</label><br />
                    <li>Come prenotarsi</li>
                    <label>prenotazione online su questo sito (https://snowcampitalia.web.app) e poi seguire le indicazioni che arriveranno alla mail con cui si è registrati</label>
                    <li>Come raggiungere la location</li>
                    <label>Dalla stazione dei treni di Bergamo prendere la linea S per Clusone e scendere a Fino del Monte.</label><br />
                    <label>La fermata è vicino all'hotel</label><br />
                    <li>Informazioni pratiche</li>
                    <label>Portare lenzuola, federe e asciugamani</label><br />
                    <label>Non sarà possibile affittarli in loco.</label><br />
                    <label>Portare indumenti invernali, e l'occorrente per andare sulla neve.</label><br />
                    <label>Inoltre sarà chiesto un documento di identità valido da presentare all'arrivo in hotel</label><br />
                </ul>
                <div className='info-contacts'>
                    <label>INFO E CONTATTI</label>
                    <div className='contacts'>
                        <FaEnvelope /> <a href='mailto:snowcampitalia@gmail.com?subject=Informazioni SnowCamp'>snowcampitalia@gmail.com</a>
                    </div>
                    <div className='contacts'>
                        <FaWhatsapp /> Franco Deriu <a href='tel:+39 3281612303'>328 1612303</a>
                    </div>
                    <div className='contacts'>
                        <FaWhatsapp /> Fabio Milone <a href='tel:+39 3478738291'> 347 8738291</a>
                    </div>
                    <div className='contacts'>
                        <FaInstagram /> Seguci su <a href='https://www.instagram.com/wol_italia/' target="_blank">Parola di Vita Italia</a>
                    </div>
                </div>
            </div>
            <div className='info-location'>
                <label>HOTEL LIBIA - FINO DEL MONTE (BG)</label>
                <label>Via da Fin 15</label>
                <iframe src={KEY.locationUrl} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" className='maps'></iframe>
            </div>
        </div>
    )
}

export default Info